var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pilllist"},_vm._l((_vm.value),function(pill){return _c('div',{key:pill,attrs:{"value":pill}},[_c('pill',{attrs:{"value":pill,"selected":false}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }